import { core_another_data_source_dialects } from './model_core_another_data_source_dialects'
import { core_another_data_source_connection_definitions } from './model_core_another_data_source_connection_definitions'

export const anotherDataSourceModels = {
  core_another_data_source_dialects,
  core_another_data_source_connection_definitions,
}
